import React from 'react';
import {Box} from "@mui/material";

interface ISettingsBooleanActionsInput {

}

const SettingsBooleanActions = ({}: ISettingsBooleanActionsInput) => {


    return (
        <Box>
            test
        </Box>
    )
}

export default SettingsBooleanActions